import {
  ASSIGN_PARTI_FAIL,
  ASSIGN_PARTI_REQUEST,
  ASSIGN_PARTI_RESET,
  ASSIGN_PARTI_SUCCESS,
  PARTI_LIST_FAIL,
  PARTI_LIST_REQUEST,
  PARTI_LIST_RESET,
  PARTI_LIST_SUCCESS,
  DOWNLOAD_TEXT_RESP_FAIL,
  DOWNLOAD_TEXT_RESP_REQUEST,
  DOWNLOAD_TEXT_RESP_RESET,
  DOWNLOAD_TEXT_RESP_SUCCESS,
  DOWNLOAD_RESP_TIME_REQUEST,
  DOWNLOAD_RESP_TIME_SUCCESS,
  DOWNLOAD_RESP_TIME_FAIL,
  DOWNLOAD_RESP_TIME_RESET,
  CREATE_PARTI_REQUEST,
  CREATE_PARTI_SUCCESS,
  CREATE_PARTI_FAIL,
  CREATE_PARTI_RESET,
  UPDATE_FITBIT_TOKEN_REQUEST,
  UPDATE_FITBIT_TOKEN_SUCCESS,
  UPDATE_FITBIT_TOKEN_FAIL,
  UPDATE_FITBIT_TOKEN_RESET,
  GET_FITBIT_SLEEP_LOG_REQUEST,
  GET_FITBIT_SLEEP_LOG_SUCCESS,
  GET_FITBIT_SLEEP_LOG_FAIL,
  GET_FITBIT_SLEEP_LOG_RESET,
  CREATE_JITAI_TASKS_REQUEST,
  CREATE_JITAI_TASKS_SUCCESS,
  CREATE_JITAI_TASKS_FAIL,
  CREATE_JITAI_TASKS_RESET,
  REFRESH_JITAI_TASKS_REQUEST,
  REFRESH_JITAI_TASKS_SUCCESS,
  REFRESH_JITAI_TASKS_FAIL,
  REFRESH_JITAI_TASKS_RESET,
  SAVE_JITAI_DATA_RESP_REQUEST,
  SAVE_JITAI_DATA_RESP_SUCCESS,
  SAVE_JITAI_DATA_RESP_FAIL,
  SAVE_JITAI_DATA_RESP_RESET,
  GET_JITAI_DATA_RESP_REQUEST,
  GET_JITAI_DATA_RESP_SUCCESS,
  GET_JITAI_DATA_RESP_FAIL,
  GET_JITAI_DATA_RESP_RESET,
  CONNECT_AMI_DEVICE_REQUEST,
  CONNECT_AMI_DEVICE_SUCCESS,
  CONNECT_AMI_DEVICE_FAIL,
  CONNECT_AMI_DEVICE_RESET,
  UNLINK_AMI_DEVICE_REQUEST,
  UNLINK_AMI_DEVICE_SUCCESS,
  UNLINK_AMI_DEVICE_FAIL,
} from '../constants/participantConstants'

// participantsData => { participants:[...], study:{...} }
export const partiListReducer = (state = { participantsData: {} }, action) => {
  switch (action.type) {
    case PARTI_LIST_REQUEST:
      return { loading: true, qx_list: [] }
    case PARTI_LIST_SUCCESS:
      return {
        loading: false,
        participantsData: action.payload,
        //pages: action.payload.pages,
        //page: action.payload.page,
        success: true,
      }
    case PARTI_LIST_FAIL:
      return { loading: false, error: action.payload }
    case PARTI_LIST_RESET:
      return { participantsData: {} }
    default:
      return state
  }
}

export const assignPartiReducer = (state = {}, action) => {
  switch (action.type) {
    case ASSIGN_PARTI_REQUEST:
      return { loading: true }
    case ASSIGN_PARTI_SUCCESS:
      return { loading: false, success: true, message: action.payload.message }
    case ASSIGN_PARTI_FAIL:
      return { loading: false, success: false, error: action.payload }
    case ASSIGN_PARTI_RESET:
      return {}
    default:
      return state
  }
}

export const downloadTextRespReducer = (state = {}, action) => {
  switch (action.type) {
    case DOWNLOAD_TEXT_RESP_REQUEST:
      return { loading: true }
    case DOWNLOAD_TEXT_RESP_SUCCESS:
      return { loading: false, success: true, message: action.payload.message }
    case DOWNLOAD_TEXT_RESP_FAIL:
      return { loading: false, success: false, error: action.payload }
    case DOWNLOAD_TEXT_RESP_RESET:
      return {}
    default:
      return state
  }
}

export const downloadRespTimeReducer = (state = {}, action) => {
  switch (action.type) {
    case DOWNLOAD_RESP_TIME_REQUEST:
      return { loading: true }
    case DOWNLOAD_RESP_TIME_SUCCESS:
      return { loading: false, success: true, message: action.payload.message }
    case DOWNLOAD_RESP_TIME_FAIL:
      return { loading: false, success: false, error: action.payload }
    case DOWNLOAD_RESP_TIME_RESET:
      return {}
    default:
      return state
  }
}

export const createPartiReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_PARTI_REQUEST:
      return { loading: true }
    case CREATE_PARTI_SUCCESS:
      return { loading: false, success: true, message: action.payload.message }
    case CREATE_PARTI_FAIL:
      return { loading: false, success: false, error: action.payload }
    case CREATE_PARTI_RESET:
      return {}
    default:
      return state
  }
}

export const updateFitbitTokenReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_FITBIT_TOKEN_REQUEST:
      return { loading: true }
    case UPDATE_FITBIT_TOKEN_SUCCESS:
      return { loading: false, success: true, message: action.payload.message }
    case UPDATE_FITBIT_TOKEN_FAIL:
      return { loading: false, success: false, error: action.payload }
    case UPDATE_FITBIT_TOKEN_RESET:
      return {}
    default:
      return state
  }
}

export const getFitbitSleepLogReducer = (state = { sleepLog: {} }, action) => {
  switch (action.type) {
    case GET_FITBIT_SLEEP_LOG_REQUEST:
      return { loading: true }
    case GET_FITBIT_SLEEP_LOG_SUCCESS:
      let sleepLog
      if (
        action.payload.data ===
        'No Fitbit account is connected to this participant'
      ) {
        sleepLog = action.payload.data
      } else {
        const removeLevelsFieldSleepLog = action.payload.sleepLog.map(
          ({ levels, ...o }) => o
        )
        sleepLog = JSON.stringify(removeLevelsFieldSleepLog, null, 2)
      }
      return {
        loading: false,
        sleepLog,
        success: true,
      }
    case GET_FITBIT_SLEEP_LOG_FAIL:
      return { loading: false, success: false, error: action.payload }
    case GET_FITBIT_SLEEP_LOG_RESET:
      return {}
    default:
      return state
  }
}

export const connectAmiDeviceReducer = (state = {}, action) => {
  switch (action.type) {
    case CONNECT_AMI_DEVICE_REQUEST:
      return { loading: true }
    case CONNECT_AMI_DEVICE_SUCCESS:
      return {
        loading: false,
        success: true,
        subject_id: action.payload.subject_id,
        ami_device_metadata: action.payload.ami_device_metadata,
      }
    case CONNECT_AMI_DEVICE_FAIL:
      return { loading: false, success: false, error: action.payload }
    case CONNECT_AMI_DEVICE_RESET:
      return {}
    case UNLINK_AMI_DEVICE_REQUEST:
      return { loading: true }
    case UNLINK_AMI_DEVICE_SUCCESS:
      return {
        loading: false,
        success: true,
        unlinked: true,
        subject_id: null,
        ami_device_metadata: action.payload.ami_device_metadata,
      }
    case UNLINK_AMI_DEVICE_FAIL:
      return { loading: false, success: false, error: action.payload }
    default:
      return state
  }
}

export const createJitaiTasksReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_JITAI_TASKS_REQUEST:
      return { loading: true }
    case CREATE_JITAI_TASKS_SUCCESS:
      return { loading: false, success: true, result: action.payload.result }
    case CREATE_JITAI_TASKS_FAIL:
      return { loading: false, success: false, error: action.payload }
    case CREATE_JITAI_TASKS_RESET:
      return {}
    default:
      return state
  }
}

export const refreshJitaiTasksReducer = (state = {}, action) => {
  switch (action.type) {
    case REFRESH_JITAI_TASKS_REQUEST:
      return { loading: true }
    case REFRESH_JITAI_TASKS_SUCCESS:
      return {
        loading: false,
        success: true,
        tasksDeleted: action.payload.tasksDeleted,
        tasksCreated: action.payload.tasksCreated,
      }
    case REFRESH_JITAI_TASKS_FAIL:
      return { loading: false, success: false, error: action.payload }
    case REFRESH_JITAI_TASKS_RESET:
      return {}
    default:
      return state
  }
}

export const saveJitaiDataRespReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_JITAI_DATA_RESP_REQUEST:
      return { loading: true }
    case SAVE_JITAI_DATA_RESP_SUCCESS:
      return { loading: false, success: true, message: action.payload.message }
    case SAVE_JITAI_DATA_RESP_FAIL:
      return { loading: false, success: false, error: action.payload }
    case SAVE_JITAI_DATA_RESP_RESET:
      return {}
    default:
      return state
  }
}

export const getJitaiDataRespReducer = (state = { responses: [] }, action) => {
  switch (action.type) {
    case GET_JITAI_DATA_RESP_REQUEST:
      return { loading: true, responses: [] }
    case GET_JITAI_DATA_RESP_SUCCESS:
      return { loading: false, success: true, responses: action.payload }
    case GET_JITAI_DATA_RESP_FAIL:
      return { loading: false, success: false, error: action.payload, responses: [] }
    case GET_JITAI_DATA_RESP_RESET:
      return { responses: [] }
    default:
      return state
  }
}
